import React, { useState } from 'react'
import { IsMobile } from '../../utils/media-queries'

export const Tabs = ({ tabs, small = false, pills = false }) => {
  const [activeIndex, setActiveIndex] = useState(0)

  // Determinamos la clase base
  let tabsGroupClass = 'tabs'

  // Si no hay 'pills' y estamos en mobile, forzamos pills
  if (!pills && IsMobile()) {
    pills = true
  }

  // Si hay pills, agregamos la clase
  if (pills) {
    tabsGroupClass += ' tabs--pills-big'
  }

  return (
    <>
      {/* Encabezados de las tabs */}
      <div className={tabsGroupClass}>
        {tabs.map((tab, index) => {
          const isActive = index === activeIndex

          // Seleccionamos el tag según si es pills o small
          const TabTag = pills ? 'h5' : small ? 'h3' : 'h2'

          return (
            <TabTag
              key={`tab-button-${tab.title}-${index}`}
              className={`tabs__tab ${isActive ? 'tabs__tab--active' : ''}`}
              onClick={() => setActiveIndex(index)}
            >
              {tab.title}
            </TabTag>
          )
        })}
      </div>

      {/* Contenido de las tabs: todas se montan, pero la inactiva se oculta */}
      {tabs.map((tab, index) => {
        const isActive = index === activeIndex
        return (
          <div
            key={`tab-content-${tab.title}-${index}`}
            style={{ display: isActive ? 'block' : 'none' }}
          >
            {tab.content}
          </div>
        )
      })}
    </>
  )
}
